import React, { useEffect } from "react";
import { Link } from 'react-router-dom'
import Footer from "./Footer";



export default function Video() {
    useEffect(() => {
            window.scrollTo(0, 0)
          }, []);


    return (
        <div>
            <div className="px-[2.5rem] lg:px-[12rem] py-[4rem]">
                <h1 className="text-3xl text-gray-700 font-bold mb-[1rem]">Next Step: Complete our HAALO Inventory</h1>
                <p className="text-gray-500">Check out the video below for a step by step preview of what's left to bring your career story to life!</p>
                <div className="video-container">
                    <iframe
                        title="Avenica Process"
                        src="https://www.youtube.com/embed/-d0ghL2WW74">
                    </iframe>
                </div>
                <br />
                <Link to="/haalo" className="text-2xl text-companyTeal underline" >Take the HAALO Assessment</Link>
                <br />
            </div>
            <div className="h-[10rem]"></div>
            <Footer />
        </div>
    )
}